"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFetchObservable = void 0;
var internalMonitoring_1 = require("../domain/internalMonitoring");
var instrumentMethod_1 = require("../tools/instrumentMethod");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/timeUtils");
var urlPolyfill_1 = require("../tools/urlPolyfill");
var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
exports.initFetchObservable = initFetchObservable;
function createFetchObservable() {
    var observable = new observable_1.Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0, instrumentMethod_1.instrumentMethod)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0, internalMonitoring_1.callMonitored)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0, internalMonitoring_1.callMonitored)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = (0, urlPolyfill_1.normalizeUrl)((typeof input === 'object' && input.url) || input);
    var startClocks = (0, timeUtils_1.clocksNow)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'complete';
        context.duration = (0, timeUtils_1.elapsed)(context.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
            observable.notify(context);
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
            observable.notify(context);
        }
    };
    responsePromise.then((0, internalMonitoring_1.monitor)(reportFetch), (0, internalMonitoring_1.monitor)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map